<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5129 6.1579V5.3804C12.5129 3.68457 11.1379 2.30957 9.4421 2.30957H5.37957C3.68457 2.30957 2.30957 3.68457 2.30957 5.3804V14.6554C2.30957 16.3512 3.68457 17.7262 5.37957 17.7262H9.45043C11.1413 17.7262 12.5129 16.3554 12.5129 14.6646V13.8787"
      :stroke="color"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1748 10.0176H8.14062"
      :stroke="color"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.7344 7.58887L18.1744 10.018L15.7344 12.448"
      :stroke="color"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
